var CoverVariables             = require("app/theme/styles/covers/CoverVariables"),
    FitableSupport             = require("enyo-ui/FitableSupport"),
    Image                      = require("app/ui/Image"),
    ImageOptimizerSupport      = require("app/ui/ImageOptimizerSupport"),
    findBestFittingPlaceholder = require("app/utils/findBestFittingPlaceholder"),
    get                        = require("object-path").get,
    placeholders               = require("app/theme/assets/placeholders"),
    kind                       = require("enyo/kind"),
    utils                      = require("enyo/utils");

require("app/ui/covers/CoverPlaceholder.less");

module.exports = kind(/** @lends  app.ui.covers.CoverPlaceholder.prototype */ {

    /**
     * @private
     */
    name: "app.ui.covers.CoverPlaceholder",

    /**
     * @private
     */
    classes: "app-ui-covers-cover-placeholder",

    /**
     * @private
     */
    mixins: [
        FitableSupport
    ],

    /**
     * The form-factor of the cover.
     *
     * @type     {string=}
     * @default  null
     * @public
     */
    formFactor: null,

    /**
     * Whether to display a title below the image
     *
     * @type     {boolean}
     * @default  true
     * @public
     */
    showTitle: true,

    /**
     * @private
     */
    components: [{
        name:       "imageWrapper",
        classes:    "app-ui-covers-cover-placeholder__image-wrapper",
        components: [{
            name:       "image",
            kind:       Image,
            mixins:     [ImageOptimizerSupport],
            classes:    "app-ui-covers-cover-placeholder__image",
            attributes: {
                loading:  "eager",
                decoding: "async"
            },
            canGenerate: Boolean(CoverVariables.usePlaceholderImage),

            /**
             * @returns  {Object}  The dimensions
             * @private
             */
            resolveImageDimensions: function() {
                return this.owner.calcImageDimensions();
            }
        }]
    }, {
        classes:    "app-ui-covers-cover-placeholder__title-bar",
        components: [{
            classes:    "app-ui-covers-cover-placeholder__title-bar__title-wrapper",
            components: [{
                classes: "app-ui-covers-cover-placeholder__title"
            }]
        }]
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.formFactorChanged();
            this.showTitleChanged();
        };
    }),

    /**
     * @private
     */
    formFactorChanged: function() {
        var formFactor  = this.get("formFactor"),
            aspectRatio,
            placeholder = null;

        if (formFactor) {
            aspectRatio = CoverVariables.getAspectRatio(formFactor);
            placeholder = CoverVariables.usePlaceholderImage
                ? findBestFittingPlaceholder(
                    placeholders,
                    aspectRatio
                )
                : null;
        }

        this.$.image.set("rawImageSrc", placeholder ? {
            width:  placeholder.width || null,
            height: placeholder.height || null,
            ratio:  placeholder.aspect_ratio || null,
            src:    get(placeholder, "url", null)
        } : null);
    },

    /**
     * @private
     */
    showTitleChanged: function() {
        var showTitle = this.get("showTitle");

        // Title visibility
        if (showTitle) {
            !this.hasClass("has-title") && this.addClass("has-title");
        }
        else {
            while (this.hasClass("has-title")) {
                this.removeClass("has-title");
            }
        }
    },

    /**
     * Calculates the width.
     *
     * @param   {number}  height  The height
     * @return  {number}  The width.
     * @public
     */
    calcWidth: function(height) {
        var formFactor = this.get("formFactor"),
            aspectRatio;

        if (height === 0 || !formFactor) {
            return 0;
        }

        aspectRatio = CoverVariables.getAspectRatio(formFactor);

        if (!aspectRatio) {
            return 0;
        }

        if (this.showTitle) {
            return Math.round((height - CoverVariables.getTitleHeightPx()) * aspectRatio);
        }
        else {
            return Math.round(height * aspectRatio);
        }
    },

    /**
     * Calculates the height.
     *
     * @param   {number}  width  The width
     * @return  {number}  The height.
     * @public
     */
    calcHeight: function(width) {
        var formFactor = this.get("formFactor"),
            aspectRatio;

        if (width === 0 || !formFactor) {
            return 0;
        }

        aspectRatio = CoverVariables.getAspectRatio(formFactor);

        if (!aspectRatio) {
            return 0;
        }

        if (this.showTitle) {
            return Math.round(width / aspectRatio + CoverVariables.getTitleHeightPx());
        }
        else {
            return Math.round(width / aspectRatio);
        }
    },

    /**
     * Calculates the dimensions of the image.
     *
     * @returns  {Object}  The dimensions
     * @public
     */
    calcImageDimensions: function() {
        var formFactor = this.get("formFactor"),
            aspectRatio,
            bounds     = {};

        if (formFactor) {
            aspectRatio = CoverVariables.getAspectRatio(formFactor);

            bounds = this.get("repeaterBounds") || this.get("cachedBounds") || this.getBounds();
            bounds = utils.clone(bounds);
        }

        if (bounds.width && aspectRatio) {
            return {
                width:  Math.round(bounds.width),
                height: Math.round(bounds.width / aspectRatio)
            };
        }
        else if (bounds.height && aspectRatio) {
            if (this.showTitle) {
                bounds.height -= Math.round(CoverVariables.getTitleHeightPx());
            }

            return {
                height: Math.round(bounds.height),
                width:  Math.round(bounds.height * aspectRatio)
            };
        }
        else {
            return {
                width:  0,
                height: 0
            };
        }
    }

});
